import { render, staticRenderFns } from "./FormilyTemplate.vue?vue&type=template&id=790dcc02&scoped=true"
import script from "./FormilyTemplate.vue?vue&type=script&lang=js"
export * from "./FormilyTemplate.vue?vue&type=script&lang=js"
import style0 from "./FormilyTemplate.vue?vue&type=style&index=0&id=790dcc02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790dcc02",
  null
  
)

export default component.exports